import styled from 'styled-components';
import { ModalSaveYourProjectTemplate } from './ModalSaveYourProjectTemplate';
import { GlobalStyled } from '@components/Modal/ModalSave/shared/GlobalStyled';

export const ModalSaveYourProject = styled(ModalSaveYourProjectTemplate)`
    ${GlobalStyled}
`;
